var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[(_vm.option.xAxis.data.length > 0)?_c('div',{staticClass:"myChart",style:({ width: '100%' }),attrs:{"id":"warnline"}}):_vm._e(),(_vm.option.xAxis.data.length == 0)?_c('span',[_vm._v("暂无数据")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }